import { ControlCode, ControlCodes } from "@theprelude/sdk";
import { AmazonIcon } from "../icons/amazon-icon";
import { CrowdstrikeIcon } from "../icons/crowdstrike-icon";
import { DefenderIcon } from "../icons/defender-icon";
import { EntraIcon } from "../icons/entra-icon";
import { GithubIcon } from "../icons/github-icon";
import { GmailIcon } from "../icons/gmail-icon";
import { GoogleIdentityIcon } from "../icons/google-identity-icon";
import { IntuneIcon } from "../icons/intune-icon";
import { JamfIcon } from "../icons/jamf-icon";
import { M365Icon } from "../icons/m365-icon";
import { OktaIcon } from "../icons/okta-icon";
import { QualysIcon } from "../icons/qualys-icon";
import { Rapid7Icon } from "../icons/rapid7-icon";
import { SentinelOneIcon } from "../icons/sentinelone-icon";
import { ServiceNowIcon } from "../icons/servicenow-icon";
import { ShieldFailIcon } from "../icons/shield-fail-icon";
import { ShieldUser } from "../icons/shield-user-icon";
import { SplunkIcon } from "../icons/splunk-icon";
import { TenableIcon } from "../icons/tenable-icon";
import { VectrIcon } from "../icons/vectr-icon";

const ControlIcons: Record<
  ControlCode,
  React.FC<Omit<React.SVGProps<SVGSVGElement>, "ref">> | null
> = {
  [ControlCodes.AWS_SSM]: AmazonIcon,
  [ControlCodes.AZURE_VM]: null,
  [ControlCodes.CROWDSTRIKE]: CrowdstrikeIcon,
  [ControlCodes.CROWDSTRIKE_IDENTITY]: CrowdstrikeIcon,
  [ControlCodes.GITHUB]: GithubIcon,
  [ControlCodes.DEFENDER]: DefenderIcon,
  [ControlCodes.DEFENDER_DISCOVERY]: DefenderIcon,
  [ControlCodes.EC2]: AmazonIcon,
  [ControlCodes.ENTRA]: EntraIcon,
  [ControlCodes.GMAIL]: GmailIcon,
  [ControlCodes.GOOGLE_IDENTITY]: GoogleIdentityIcon,
  [ControlCodes.INTUNE]: IntuneIcon,
  [ControlCodes.JAMF]: JamfIcon,
  [ControlCodes.M365]: M365Icon,
  [ControlCodes.OKTA]: OktaIcon,
  [ControlCodes.QUALYS]: QualysIcon,
  [ControlCodes.QUALYS_DISCOVERY]: QualysIcon,
  [ControlCodes.RAPID7]: Rapid7Icon,
  [ControlCodes.RAPID7_DISCOVERY]: Rapid7Icon,
  [ControlCodes.S3]: AmazonIcon,
  [ControlCodes.SENTINELONE]: SentinelOneIcon,
  [ControlCodes.SERVICENOW]: ServiceNowIcon,
  [ControlCodes.SPLUNK]: SplunkIcon,
  [ControlCodes.VECTR]: VectrIcon,
  [ControlCodes.TENABLE]: TenableIcon,
  [ControlCodes.TENABLE_DISCOVERY]: TenableIcon,
  [ControlCodes.INTUNE_HOST_FIREWALL]: IntuneIcon,
  [ControlCodes.INVALID]: null,
  [ControlCodes.NONE]: ShieldFailIcon,
} as const;

export const ControlIcon: React.FC<
  React.SVGProps<SVGSVGElement> & { control: ControlCode }
> = ({ control, ...props }) => {
  const Icon = ControlIcons[control];

  if (!Icon) {
    return <ShieldUser {...props} />;
  }

  return <Icon {...props} />;
};
